// extracted by mini-css-extract-plugin
export default {"card":"Day_card__T+fGa","header":"Day_header__EubIX","user-action":"Day_user-action__QUyoc","user-toggle":"Day_user-toggle__bFLbF","user-label":"Day_user-label__fynwk"};